import { createTheme } from '@mui/material/styles';
import { createMaterialPaginationStyles } from './table/pagination';
import { createMaterialReactTableTheme } from './table/table';
import { createMuiCommonTabTheme } from './tab';
import { baseTheme } from './base';

export const baseFormMuiTheme = createTheme({
  palette: baseTheme.palette,
  typography: baseTheme.typography,
  components: {
    ...createMaterialReactTableTheme(),
    ...createMaterialPaginationStyles(),
    ...createMuiCommonTabTheme(),
  },
});
